import { getBuildType } from "../utils/Utilities";

export const ISDLUrl = () =>{
    let url = "";
    switch(getBuildType()){
        case "DEV":
            url = process.env.REACT_APP_ISDL_URL_DEV;
            break;
        case "QA":
            url = process.env.REACT_APP_ISDL_URL_QA;
            break;
        default:
        case "PROD":
            url = process.env.REACT_APP_ISDL_URL_PROD;
            break;
    }
    return url;
}

export const ISDLFunctionsKey = () =>{
    let key = "";
    switch(getBuildType()){
        case "DEV":
            key = process.env.REACT_APP_FUNCTION_KEY_DEV;
            break;
        case "QA":
            key = process.env.REACT_APP_FUNCTION_KEY_QA;
            break;
        default:
        case "PROD":
            key = process.env.REACT_APP_FUNCTION_KEY_PROD;
            break;
    }
    return key;
}

export const ISDLClientID = () =>{
    let key = "";
    switch(getBuildType()){
        case "DEV":
            key = process.env.REACT_APP_ISDL_CLIENTID_DEV;
            break;
        default:
        case "QA":
        case "PROD":
            key = process.env.REACT_APP_ISDL_CLIENTID_PROD;
            break;
    }
    return key;
}
